export default __webpack_public_path__ + "static/media/APACHE RTR 160 2V_5.70c41f09.webp";